module.exports = {
    productTileAvailability: {
        notRanged: 'Sorry, temporarily unavailable.',
        notRangedMobile: 'Sorry, temporarily unavailable.',
        outOfStock: 'Sorry, currently not in stock',
        outOfStockMobile: 'Currently not in stock.',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/product-tile-availability.js